import React, { Fragment, useEffect, useState } from "react";
import { Box, Container, Typography, Grid, Button } from "@material-ui/core";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { emailValid } from "../lib/validation";
import { Link, useNavigate } from "react-router-dom";
import ButtonLoader from "../components/ButtonLoader";
import SectionHeader from "../components/SectionHeader";
import { Environment } from "../utils/environments";
export default function PasswordResetRequest() {
  useEffect(() => {
    document.title = "パスワード再発行 | じぶん専用IT相談室";
  }, []);
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState<boolean | string>(false);
  const [resetError, setResetError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  /**
   *
   * @param e button event
   * posts reset request
   */
  async function handleReset(e) {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);
    const emailId = e.target.elements[0].value.trim() || email;
    setEmailError(false);
    setResetError(false);
    if (!emailValid(emailId)) {
      if (email.length > 319) {
        setEmailError("メールアドレスは、319文字以内で入力してください");
      } else {
        setEmailError("メールアドレス形式で入力してください");
      }
      setLoading(false);
      return;
    }
    try {
      await httpPost(
        {
          pathName: "password-reset-request",
          bodyParams: {
            email: emailId,
          },
        },
        false
      ).then((response: AxiosResponse<any>) => {
        if (response.status == 200) {
          navigate("/password-reset");
        }
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error.response.status >= 400 && error.response.status <= 499) {
        setResetError(true);
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
    } finally {
      setLoading(false);
    }
  }
  return (
    <Fragment>
      <Box component={"section"} className="section bg-dots">
        <Container className="container" style={{ marginBottom: "50px" }}>
          <SectionHeader
            currentPage={"パスワード変更用の認証コードを送信します"}
            preHeading={"Reset"}
          />
          <Typography className="text-center mobile-text-left">
            入力いただいたアドレス宛にパスワード変更用の認証URLを送信します。
          </Typography>
        </Container>
        <Container className="container">
          <Box className="element-box">
            <form onSubmit={handleReset}>
              <Grid container spacing={2} alignItems="center">
                <Grid item md={3} sm={3} xs={12}>
                  <label>
                    メールアドレス<span className="required">必須</span>
                  </label>
                </Grid>
                <Grid item md={6} sm={9} xs={12}>
                  <input
                    type="text"
                    maxLength={319}
                    placeholder="メールアドレス"
                    className={
                      emailError ? "input-field invalid-input" : "input-field"
                    }
                    onChange={(e) => setEmail(e.target.value.trim())}
                  />
                  {emailError && (
                    <Typography className="error-message">
                      {emailError}
                    </Typography>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ margin: "30px 0", textAlign: "center" }}
                >
                  {loading && <div className="button-overlay"></div>}
                  <button
                    className="classification-btn"
                    type="submit"
                    disabled={email.length < 1 || loading}
                  >
                    {loading ? <ButtonLoader /> : " パスワード再発行"}
                  </button>
                  {resetError && (
                    <Typography className="error-message">
                      メンバーが見つかりません
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </form>
            <Typography component={"p"} className="text-center">
              <Link to={"/login"} style={{ color: "#2683c3" }}>
                ログイン画面
              </Link>
              に戻る
            </Typography>
          </Box>
        </Container>
      </Box>
    </Fragment>
  );
}
